import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplierEnquiries, SupplierEnquiry } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './supplierEnquiriesModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplierEnquiry> useData={useSupplierEnquiries} config={config} />;
};

export default List;
